export default {
    exnum: '展位：',
    exhibitor: '参展商：',
    area: '展位面积：',
    name: '名称',
    mandanary: '是否必缴',
    unit_price: '单价',
    num: '数量/时间段',
    canForegift: '是否为押金',
    canInvoice: '是否可开发票',
    sumary: '小计',
    remark: '备注',
    start_time: '开始时间',
    end_time: '结束时间',
    choose_fee: '已选中费用总计',
    go_pay: '去支付',
    go_rent: '继续商品租赁',
    foregift_remark: '申请退押金说明',
    foregift_notice_1: '申请退还押金，请在首页点击',
    foregift_notice_2: '"申请退押金"',
    foregift_notice_3: '按钮，并填写相关资料',
    sure_btn: '确定',
    invoice_remark: '申请发票说明',
    invoice_notice_1: '申请发票，请在首页点击',
    invoice_notice_2: '"申请发票"',
    invoice_notice_3: '按钮，并填写相关资料',
    price_notice: '计价方式说明',
    count_way: '计价方式',
    start_time_less_error: '您选择的费用开始时间不得小于',
    start_time_between_error: '您选择的费用开始时间不得小于结束时间',
    start_time_more_error: '您选择的费用开始时间不得大于',
    end_time_less_error: '您选择的费用结束时间不得小于',
    end_time_between_error: '您选择的费用结束时间不得大于',
    end_time_more_error: '您选择的费用结束时间不得小于开始时间',
    back_to_booth: '返回选择展位',
    no_message: '暂未选择展位，没有费用信息，请返回选择展位后再查看',
    fee_total: '费用总价',
	'勾选展位中需要缴纳的费用(需要现场现金刷卡或使用预授权支付的不需要在这里勾选，可以在现场完成支付)':'勾选展位中需要缴纳的费用(需要现场现金刷卡或使用预授权支付的不需要在这里勾选，可以在现场完成支付)',
	'该项费用不可重复缴纳':'该项费用不可重复缴纳',
	'请先选择时间后再勾选该项费用':'请先选择时间后再勾选该项费用',
  '下单说明':'下单说明',
  '采用单一价格计算':'采用单一价格计算',
  '单价':'单价:',
  '总价':'总价:',
  '采用最小单位计价':'采用最小单位计价',
  '单价时长总价':'（单价 * 时长 = 总价）',
  '单位计算总价':'（单价 * （时长/计价单位数值） = 总价）',
  '加班时长':'加班时长：',
  '小时':'小时',
  '费用计算的最小时长':'费用计算的时长计算单位：',
  '最小面积':'（小时），最小面积：',
  '最小单位计算':'（平方米），不足部分按最小单位计算。',
  '采用面积范围计价':'采用面积范围计价',
  '采用阶梯计价':'采用阶梯计价',
  '未选择费用项':'未选择费用项，无支付费用',
  '报馆费用缴纳':'报馆费用缴纳',
  '费用列表':'费用列表',
  '已选展位':'已选展位',
  '共':'共',
  '个':'个',
  "选择数量":"选择数量",
  "可选时间范围":"可选时间范围",
  "选择时间":"选择时间",
  "计价说明":"计价说明",
  "请选择需要缴纳的费用项，当前展位已选中费用合计":"请选择需要缴纳的费用项，当前展位已选中费用合计",
  
  "已选择":"已选择",
  "个展位，费用合计":"个展位，费用合计",
  "返回上一步":"返回上一步",
  "去结算":"去结算",
  "您选择的时间不在可选范围内":"您选择的时间不在可选范围内"

}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/fixedFee.js